import { Controller } from "stimulus"

import 'swiper/css/swiper.min.css'
import Swiper from 'swiper';

export default class extends Controller {
  connect() {

    if (document.querySelector(".swiper-container") !== null) {

     var swiper = new Swiper('.swiper-container', {
        slidesPerView: 1,
        centeredSlides: true,
        loop: false,
        speed: 500,
        effect: 'fade',
        spaceBetween: 0,
        touchRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
      });

    }

  }
}
